import { useTranslation } from 'react-i18next'

import { getResponseContent } from '../../../api/responses'
import useApiCall from '../../../api/useApiCall'
import { useResponsesStore } from '../../../stores/responsesStore'
import LoadingSection from '../../LoadingSection/LoadingSection'
import NotFound from '../../NotFound/NotFound'

import AddResponse from './AddResponse/AddResponse'
import Message from './Message/Message'

import styles from './response-section.module.scss'

function ResponseSection() {
    const [
        { currentResponseId, responseContent, isResponseAdding },
        { setResponseContent },
    ] = useResponsesStore()

    const { t } = useTranslation()

    const [{ loading }] = useApiCall(
        getResponseContent,
        setResponseContent,
        currentResponseId
    )

    if (loading) {
        return <LoadingSection />
    }

    return (
        <section className={styles.responsesSection}>
            <div className={styles.responsesSection__results}>
                {responseContent.length} {t('results')}
            </div>
            {isResponseAdding && <AddResponse />}
            {responseContent.length ? (
                <div className={styles.responsesSection__messages}>
                    {responseContent.map((message) => (
                        <Message key={message._id} message={message} />
                    ))}
                </div>
            ) : (
                <NotFound title={t('no_responses')} />
            )}
        </section>
    )
}

export default ResponseSection
